import { useSlideshowContext } from '@fukku/slideshow/hooks/useSlideshowContext/useSlideshowContext'
import { useStore } from 'zustand'

export const useActiveItemIndexStore = () => {
	const { activeItemIndexStore } = useSlideshowContext()
	return useStore(activeItemIndexStore)
}
